/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ field: NonNullable<unknown>, max: NonNullable<unknown> }} Warning_Too_Many_ValuesInputs */

const en_warning_too_many_values = /** @type {(inputs: Warning_Too_Many_ValuesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.field} lists more than ${i?.max} values, the rest is ignored`)
};

const de_warning_too_many_values = /** @type {(inputs: Warning_Too_Many_ValuesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.field} enthält mehr als ${i?.max} Werte, der Rest wird ignoriert`)
};

/**
* | output |
* | --- |
* | "{field} lists more than {max} values, the rest is ignored" |
*
* @param {Warning_Too_Many_ValuesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const warning_too_many_values = /** @type {((inputs: Warning_Too_Many_ValuesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warning_Too_Many_ValuesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_warning_too_many_values(inputs)
	return en_warning_too_many_values(inputs)
});